import CAMPAIGN_DETAIL_TEMPLATE from "./campaign.template";
import ENTITY_DETAIL_TEMPLATE from "./entity.template";
import LAWFIRM_DETAIL_TEMPLATE from "./lawfirm.template";
import PROVIDER_DETAIL_TEMPLATE from "./provider.template";

const DETAIL_TEMPLATE = {
  lawfirm: LAWFIRM_DETAIL_TEMPLATE,
  entity: ENTITY_DETAIL_TEMPLATE,
  provider: PROVIDER_DETAIL_TEMPLATE,
  campaign: CAMPAIGN_DETAIL_TEMPLATE,
};

export default DETAIL_TEMPLATE;
